import React from 'react';
import PropTypes from 'prop-types';

import classes from './TwoOptionsSelector.css';

const twoOptionSelector = props => {
  const { select1, select2, selected1, selected2, title1, title2 } = props;
  return (
    <div className={classes.TwoOptionSelector}>
      <div className={classes.SelectorWrapper}>
        <div className={selected1 ? classes.Active : null} onClick={select1}>
          <h2>{title1}</h2>
        </div>
        <div className={selected2 ? classes.Active : null} onClick={select2}>
          <h2>{title2}</h2>
        </div>
      </div>
    </div>
  );
};

twoOptionSelector.propTypes = {
  title1: PropTypes.string.isRequired,
  title2: PropTypes.string.isRequired,
  selected1: PropTypes.bool.isRequired,
  selected2: PropTypes.bool.isRequired,
  select1: PropTypes.func,
  select2: PropTypes.func
};

export default twoOptionSelector;
